// extracted by mini-css-extract-plugin
export var dropdown = "_ub-0";
export var imageWrapper = "_ub-3";
export var itemNameContainer = "_ub-1";
export var productImage = "_ub-2";
export var spinnerWrapper = "_ub-4";